import axios from 'axios';

const version = 'v1';
const basePath = 'agency';

export async function getAll(params) {
  return axios.request({
    url: `/${version}/${basePath}/list`,
    method: 'get',
    params: {
      order_by: 'id',
      order_mode: 'asc',
      ...params,
    },
  });
}
